import { QuickDrawServiceAPI } from '../../services/QuickDrawServiceAPI';

export class ControlPanel extends Phaser.GameObjects.Container {
  private readonly button;
  private editBtn;
  // @ts-ignore
  private drawIdText;
  private drawId;
  private readonly screenHeight;
  private readonly screenWidth;
  private popup;
  private messagePopup;
  private messageText;
  private container;
  // @ts-ignore
  private doneBtn;
  // @ts-ignore
  private closeBtn;
  private readonly availableDraws: {};
  private readonly config;
  private popupOverlay;

  constructor(scene, screenWidth, screenHeight) {
    super(scene);
    this.config = window._po_gm.config;
    this.availableDraws = this.config.availableDraws;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.popup = document.getElementById('ftf-input-popup');
    this.popup.style.visibility = 'hidden';
    this.messagePopup = document.getElementById('ftf-message-popup');
    this.messagePopup.style.visibility = 'hidden';
    this.drawId = this.config.drawId;
    this.scene.add.sprite(screenWidth / 2 - 90, screenHeight - 56, 'drawingid');
    this.drawIdText = this.scene.add.text(screenWidth / 2 - 165, screenHeight - 53, this.drawId, {
      font: '32px Jost',
      color: '0x00000'
    });
    this.editBtn = this.scene.add.sprite(screenWidth / 2 - 23, screenHeight - 38, 'edit').setInteractive({ useHandCursor: true });
    this.editBtn.inputEnabled = true;
    this.editBtn.on('pointerdown', this.showInputPopup.bind(this, false));
    this.button = this.scene.add.sprite(screenWidth / 2 + 170, screenHeight - 58, 'pause').setInteractive({ useHandCursor: true });
    this.button.on('pointerdown', this.toggleButtonState.bind(this));
    this.scene.events.on('multiplierNumberAnimationEnded', this.setReplayButton, this);
    this.doneBtn = this.addClickListener('ftf-popup-submit', this.doneClick);
    this.closeBtn = this.addClickListener('ftf-message-submit', this.closeClick);
    if (!!this.drawId && !!this.config.drawResult) {
      this.availableDraws[this.drawId] = { drawResult: this.config.drawResult, drawId: this.drawId };
    }
  }

  addClickListener = (elementId, method) => {
    const oldElement = document.getElementById(elementId);
    const newElement = oldElement?.cloneNode(true);
    if (newElement) {
      newElement.addEventListener('click', method);
      oldElement?.parentNode?.replaceChild(newElement, oldElement);
    }
    return newElement;
  };

  doneClick = () => {
    const regex = /^[0-9]+$/;
    const drawIdInput = document.getElementById('ftf-input-draw-id') as HTMLInputElement;
    if (regex.test(drawIdInput.value)) {
      // @ts-ignore
      this.scene.resumeTimer();
      this.scene.input.enabled = true;
      this.popupOverlay?.destroy();
      this.popup.style.visibility = 'hidden';
      if (drawIdInput.value) {
        this.updateDrawId(drawIdInput.value);
      }
    } else {
      this.popupOverlay?.destroy();
      this.popup.style.visibility = 'hidden';
      this.updateDrawId(this.drawId.toString());
      this.showMessage('Invalid Draw id/Number');
    }
  };

  closeClick = () => {
    // @ts-ignore
    this.scene.resumeTimer();
    this.scene.input.enabled = true;
    this.popupOverlay?.destroy();
    this.messagePopup.style.visibility = 'hidden';
  };

  showMessage(message) {
    // @ts-ignore
    this.scene.pauseTimer();
    this.scene.input.enabled = false;
    this.messagePopup.style.visibility = 'visible';
    this.popupOverlay = this.addBackDrop();
    this.messageText = document.getElementById('ftf-message-label');
    this.messageText.innerHTML = message;
  }

  updateDrawId = drawNumber => {
    this.adjustControlButton();
    if (drawNumber === this.drawId.toString()) {
      if (!!this.button && this.button.texture.key) {
        const imageName = this.button.texture.key;
        if (imageName === 'play') {
          this.button.setTexture('pause');
        }
      }
      return;
    }

    if (!this.availableDraws || !this.availableDraws[drawNumber]) {
      this.processMissingDrawId(drawNumber);
    } else {
      this.animateDraw(drawNumber);
    }
  };

  adjustControlButton() {
    const imageName = this.getButtonImageName();
    if (imageName === 'replay') {
      this.setReplayButton();
    } else {
      this.setPauseButton();
    }
  }

  getButtonImageName() {
    if (!!this.button && this.button.texture.key) {
      return this.button.texture.key;
    } else {
      return '';
    }
  }

  setLoading(loading) {
    window.model.setLoading(loading);
    const spinner = document.getElementById('ftf-spinner');
    if (spinner) {
      if (loading) {
        // @ts-ignore
        this.scene.pauseTimer();
        spinner.style.visibility = 'visible';
      } else {
        // @ts-ignore
        this.scene.resumeTimer();
        spinner.style.visibility = 'hidden';
      }
    }
  }

  processMissingDrawId = drawNumber => {
    try {
      parseInt(drawNumber);
    } catch {
      this.showMessage('Invalid Draw id/Number');
      return;
    }

    this.setLoading(true);
    const strDrawNumber = drawNumber.toString();
    const quickDrawResult = QuickDrawServiceAPI.getQuickDrawJackpotResultsByDrawId(this.config.gameId, strDrawNumber, 0, 1);
    quickDrawResult.then(result => {
      this.setLoading(false);
      if (result.length === 0) {
        const sizeOfAvailableDraws = Object.keys(this.availableDraws).length;
        if (sizeOfAvailableDraws > 0) {
          const sortedKeys = Object.keys(this.availableDraws);
          sortedKeys.sort();
          const lastDrawId = sortedKeys[sizeOfAvailableDraws - 1];
          if (parseInt(drawNumber, 10) > parseInt(lastDrawId, 10)) {
            this.showMessage('The selected draw is not yet available');
          } else {
            this.showMessage('Invalid Draw id/Number');
          }
        } else {
          this.showMessage('Invalid Draw id/Number');
        }
      } else {
        this.availableDraws[drawNumber] = { drawResult: result[0].drawResult };
        this.animateDraw(drawNumber);
      }
    });
  };

  animateDraw = drawNumber => {
    this.drawId = drawNumber;
    this.updateConfig(drawNumber);
    this.replay();
  };

  updateConfig = (drawNumber: number) => {
    const selectedDraw = this.availableDraws[drawNumber];
    this.config.drawId = drawNumber;
    this.config.drawResult = selectedDraw?.drawResult;
  };

  toggleButtonState = () => {
    const imageName = this.getButtonImageName();
    if (imageName === 'pause') {
      this.button.setTexture('play');
      //@ts-ignore
      this.scene.pauseTimer();
    } else if (imageName === 'play') {
      this.button.setTexture('pause');
      //@ts-ignore
      this.scene.resumeTimer();
    } else if (imageName === 'replay') {
      this.replay();
    }
  };

  replay() {
    this.scene.game.sound.stopAll();
    this.cleanUpListeners();
    this.scene.scene.stop('BonusMultiplierScene');
    this.scene.scene.start('WelcomeScene');
  }

  setReplayButton() {
    this.button.setTexture('replay');
  }

  setPauseButton() {
    this.button.setTexture('pause');
  }

  cleanUpListeners() {
    this.scene.events.removeAllListeners('multiplierNumberAnimationEnded');
  }

  showInputPopup = () => {
    // @ts-ignore
    this.scene.pauseTimer();
    this.scene.input.enabled = false;
    this.popup.style.visibility = 'visible';
    this.popupOverlay = this.addBackDrop();
    this.container = document.getElementById('ftf-draw-container');
    this.container.style.display = 'visible';
    const drawIdInput = document.getElementById('ftf-input-draw-id') as HTMLInputElement;
    drawIdInput.value = this.drawId;
  };

  addBackDrop = () => {
    const popupOverlay = this.scene.make.renderTexture({ width: this.screenWidth, height: this.screenHeight }, true);
    return popupOverlay.fill(0x000000, 0.5);
  };
}
